// extracted by mini-css-extract-plugin
export default {"chartCardContent":"styles_chartCardContent__7MVMk"};